/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
const enum Digits {
  MINIMUM = 2,
  MAXIMUM = 2,
}

export default Digits;
